import { Routes } from '@angular/router';
import { AuthGuard } from 'src/shared/authguard/auth-guard.guard';
import { MapComponent } from 'src/shared/components/map/pages/map.component';
import { AuditGuard } from 'src/shared/authguard/audit.guard';
import { UserComponent } from 'src/shared/components/userprofile/user/pages/user.component';
import { ReportComponent } from 'src/shared/components/report/pages/report.component';
import { CommandsComponent } from 'src/shared/components/commands/commands.component';
import { ReportChartsComponent } from 'src/shared/components/report-charts/pages/report-charts.component';
import { ManageUserComponent } from 'src/shared/components/manage-user/pages/manage-user.component';
import { ReportAuditComponent } from 'src/shared/components/report-audit/pages/report-audit.component';
import { CompaniesComponent } from 'src/shared/components/register/pages/companies/companies.component';
import { TensionComponent } from 'src/shared/components/register/pages/tension/tension.component';
import { ServiceOrderComponent } from 'src/shared/components/service-order/service-order.component';
import { NotFoundComponent } from 'src/shared/components/not-found/not-found.component';
import { AuditEditComponent } from 'src/shared/components/report-audit/audit-edit/pages/audit-edit.component';
// import { AlertRulesComponent } from 'src/shared/components/alert-rules/pages/alert-rules.component';
import { UnitMeasurementComponent } from 'src/shared/components/register/pages/unit-measurement/unit-measurement.component';
import { PropertiesComponent } from 'src/shared/components/register/pages/properties/properties.component';
import { InstallationSiteComponent } from 'src/shared/components/register/pages/installation-site/installation-site.component';
import { FirmwaresComponent } from 'src/shared/components/register/pages/firmwares/firmwares.component';
import { EquipmentsComponent } from 'src/shared/components/register/pages/equipments/equipments.component';
import { EquipmentTypeComponent } from 'src/shared/components/register/pages/equipment-type/equipment-type.component';
import { HardwaresComponent } from 'src/shared/components/register/pages/hardwares/hardwares.component';
import { ParametersComponent } from 'src/shared/components/register/pages/parameters/parameters.component';
import { ComponentsComponent } from 'src/shared/components/register/pages/components/components.component';
import { GatewaysComponent } from 'src/shared/components/register/pages/gateways/gateways.component';
import { AlertsComponent } from 'src/shared/components/alerts/pages/alerts.component';
import { MetersComponent } from 'src/shared/components/register/pages/meters/meters.component';
import { LampsTypeComponent } from 'src/shared/components/register/pages/lamps-type/lamps-type.component';
import { InstallationsComponent } from 'src/shared/components/register/pages/installations/installations.component';
import { DivisionComponent } from 'src/shared/components/register/pages/division/division.component';
import { LogsComponent } from 'src/shared/components/logs/logs.component';
import { InstallationLogComponent } from 'src/shared/components/logs/pages/installation-log/installation-log.component';
import { InstallationSiteLogComponent } from 'src/shared/components/logs/pages/installation-site-log/installation-site-log.component';
import { EquipmentLogComponent } from 'src/shared/components/logs/pages/equipment-log/equipment-log.component';
import { UserLogComponent } from 'src/shared/components/logs/pages/user-log/user-log.component';
import { RegisterComponent } from 'src/shared/components/register/register.component';
import { LoginComponent } from 'src/shared/components/login/pages/login.component';
import { CircuitBoxComponent } from 'src/shared/components/register/pages/circuit-box/circuit-box.component';
import { ImportsCSVComponent } from 'src/shared/components/imports-csv/imports-csv.component';
import { ImportsCsvUpdateInstallationsComponent } from 'src/shared/components/imports-csv/pages/imports-installations/imports-csv-update-installations/imports-csv-update-installations/imports-csv-update-installations.component';
import { ImportsCsvCreateEquipmentsComponent } from 'src/shared/components/imports-csv/pages/imports-equipments/imports-csv-create-equipments/imports-csv-create-equipments/imports-csv-create-equipments.component';
import { ImportsCsvCreateInstallationsComponent } from 'src/shared/components/imports-csv/pages/imports-installations/imports-csv-create-installations/imports-csv-create-installations/imports-csv-create-installations.component';
import { PermissionsGroupComponent } from 'src/shared/components/permissions-group/permissions-group.component';
import { ImportsCsvUpdateEquipmentComponent } from 'src/shared/components/imports-csv/pages/imports-equipments/imports-csv-update-equipments/imports-csv-update-equipment/imports-csv-update-equipment.component';
import { ImportsCsvInactivateInstallationsComponent } from 'src/shared/components/imports-csv/pages/imports-installations/imports-csv-inactivate-installations/imports-csv-inactivate-installations/imports-csv-inactivate-installations.component';
import { ImportsCsvDisassociateEquipmentInInstallationComponent } from 'src/shared/components/imports-csv/pages/imports-installations/imports-csv-disassociate-equipment/imports-csv-disassociate-equipment-in-installation/imports-csv-disassociate-equipment-in-installation.component';
import { ImportCsvUpdateInstallationSitesComponent } from 'src/shared/components/imports-csv/pages/imports-installation-sites/import-csv-update-installation-sites/import-csv-update-installation-sites.component';
import { UserTraceLogComponent } from 'src/shared/components/logs/pages/user-trace-log/user-trace-log.component';
import { SchedulingComponent } from 'src/shared/components/scheduling/scheduling.component';
import { AccessBlockerComponent } from 'src/shared/components/access-blocker/access-blocker.component';
import { ImportsCsvCreateServiceOrderComponent } from 'src/shared/components/imports-csv/pages/imports-service-order/create-service-order/imports-csv-create-service-order/imports-csv-create-service-order.component';
import { MapWrapperComponent } from 'src/shared/components/map/map-wrapper.component';
import { MapOnlyGuard } from 'src/shared/authguard/map-only.guard';
import { ImportsCsvEquipmentInInstallationsComponent } from 'src/shared/components/imports-csv/pages/imports-installations/imports-csv-equipment-installation/imports-csv-equipment-in-installations.component';

export const routes: Routes = [
    {
        path: '',
        component: MapWrapperComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'map',
        component: MapWrapperComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'user',
        component: UserComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    { path: 'login', component: LoginComponent },
    {
        path: 'report',
        component: ReportComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'commands',
        component: CommandsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'scheduling',
        component: SchedulingComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'reportcharts',
        component: ReportChartsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'manageuser',
        component: ManageUserComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'permissionsGroup',
        component: PermissionsGroupComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'audit',
        component: ReportAuditComponent,
        canActivate: [AuthGuard, AuditGuard],
    },
    {
        path: 'audit/auditEdit/:id',
        component: AuditEditComponent,
        canActivate: [AuthGuard, AuditGuard],
    },
    {
        path: 'serviceorder',
        component: ServiceOrderComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    // {
    //   path: 'alertrules',
    //   component: AlertRulesComponent,
    //   canActivate: [AuthGuard],
    // },
    {
        path: 'alerts/system',
        component: AlertsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
        data: { alertType: 'ALERTS' },
    },
    {
        path: 'alerts/equipment',
        component: AlertsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
        data: { alertType: 'ALERTS_EQUIPMENT' },
    },
    {
        path: 'logs',
        component: LogsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV',
        component: ImportsCSVComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/installationsImport/equipment',
        component: ImportsCsvEquipmentInInstallationsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/installationsImport/installations-update',
        component: ImportsCsvUpdateInstallationsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/installationsImport/installations-inactivate',
        component: ImportsCsvInactivateInstallationsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/equipmentsImport/equipments-create',
        component: ImportsCsvCreateEquipmentsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/equipmentsImport/equipments-update',
        component: ImportsCsvUpdateEquipmentComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/installationsImport/installations-create',
        component: ImportsCsvCreateInstallationsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/installationsImport/disassociate-equipment',
        component: ImportsCsvDisassociateEquipmentInInstallationComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/installationSiteImport/installation-sites-update',
        component: ImportCsvUpdateInstallationSitesComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'importsCSV/serviceOrderImport/create-service-order',
        component: ImportsCsvCreateServiceOrderComponent,
        canActivate: [AuthGuard, MapOnlyGuard]
    },
    {
        path: 'logs/installation',
        component: InstallationLogComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'logs/installation_site',
        component: InstallationSiteLogComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'logs/equipment',
        component: EquipmentLogComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'logs/user',
        component: UserLogComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'logs/user-trace',
        component: UserTraceLogComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/companies',
        component: CompaniesComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/tension',
        component: TensionComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/unit-measurement',
        component: UnitMeasurementComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/installation-site',
        component: InstallationSiteComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/parameters',
        component: ParametersComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/properties',
        component: PropertiesComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/firmwares',
        component: FirmwaresComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/equipments',
        component: EquipmentsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/equipment-type',
        component: EquipmentTypeComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/hardwares',
        component: HardwaresComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/gateways',
        component: GatewaysComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/components',
        component: ComponentsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/meters',
        component: MetersComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/lampsType',
        component: LampsTypeComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/installations',
        component: InstallationsComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/division',
        component: DivisionComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'register/circuit-box',
        component: CircuitBoxComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: 'access-blocker',
        component: AccessBlockerComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: '404',
        component: NotFoundComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
    {
        path: '**',
        component: NotFoundComponent,
        canActivate: [AuthGuard, MapOnlyGuard],
    },
];